export enum DepartmentType {
  Workshop = 'workshop',
  VehicleSales = 'vehicle_sales',
  Counter = 'counter'
}
